var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "login-reg notop" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "log-box fullw" }, [
        _c("div", {}, [
          _c(
            "div",
            {
              staticClass: "top-video-container",
              class: { compact: !_vm.item.media }
            },
            [
              _c("edit-video", {
                attrs: {
                  media: _vm.item.media,
                  thumbnail: _vm.item.thumbnail,
                  chapters: _vm.item.chapters
                },
                on: { delete: _vm.deleteVideo, set: _vm.setVideo }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "post-container" }, [
            _c(
              "div",
              { staticClass: "post-head" },
              [
                _c("div", { staticClass: "head-props" }, [
                  _c(
                    "div",
                    {
                      staticClass: "type",
                      class: { open: _vm.typeOpened },
                      staticStyle: {
                        "max-width": "80% !important",
                        width: "500px !important"
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.typeOpened = !_vm.typeOpened
                        }
                      }
                    },
                    [
                      _vm.item.type
                        ? _c("span", [_vm._v(_vm._s(_vm.item.type.title))])
                        : _c("span", [_vm._v("(no type selected)")]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        { staticStyle: { "z-index": "20" } },
                        _vm._l(_vm.types, function(type) {
                          return _c(
                            "li",
                            {
                              class: {
                                active:
                                  _vm.item.type && type.id == _vm.item.type.id
                              },
                              on: {
                                click: function($event) {
                                  _vm.select("type", type)
                                  _vm.typeOpened = false
                                }
                              }
                            },
                            [_vm._v(_vm._s(type.title))]
                          )
                        }),
                        0
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "group",
                      class: { open: _vm.groupOpened },
                      staticStyle: { "max-width": "230px" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.groupOpened = !_vm.groupOpened
                        }
                      }
                    },
                    [
                      _vm.item.parent
                        ? _c("span", [_vm._v(_vm._s(_vm.item.parent.subtitle))])
                        : !_vm.item.subtitle
                        ? _c("span", [_vm._v("(standalone video)")])
                        : _c("span", [_vm._v("(first video of a group)")]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        {
                          staticStyle: {
                            "z-index": "20",
                            width: "600px",
                            "max-height": "250px",
                            overflow: "auto"
                          }
                        },
                        [
                          _c(
                            "li",
                            {
                              class: { active: _vm.item.parent == null },
                              staticStyle: { width: "auto" },
                              on: {
                                click: function($event) {
                                  _vm.select("parent", null)
                                  _vm.groupOpened = false
                                }
                              }
                            },
                            [_vm._v("(standalone or first video)")]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.parents, function(parent) {
                            return _c(
                              "li",
                              {
                                class: {
                                  active:
                                    _vm.item.parent &&
                                    parent.id == _vm.item.parent.id
                                },
                                staticStyle: { width: "auto" },
                                on: {
                                  click: function($event) {
                                    _vm.select("parent", parent)
                                    _vm.groupOpened = false
                                  }
                                }
                              },
                              [_vm._v(_vm._s(parent.subtitle))]
                            )
                          })
                        ],
                        2
                      )
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.item.parent
                    ? _c("div", { staticClass: "group2" }, [
                        _c("label", [_vm._v("Group title")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.item.subtitle,
                              expression: "item.subtitle"
                            }
                          ],
                          staticClass: "text-field",
                          domProps: { value: _vm.item.subtitle },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.item,
                                "subtitle",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.item.media && !_vm.testEditor && !_vm.chapterEditor
                    ? _c(
                        "div",
                        {
                          staticClass: "thumb",
                          class: { open: _vm.thumbnailEditor }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "thumb-box",
                              on: {
                                click: function($event) {
                                  _vm.thumbnailEditor = !_vm.thumbnailEditor
                                }
                              }
                            },
                            [_c("i")]
                          ),
                          _vm._v(" "),
                          _vm.thumbnailEditor
                            ? _c("thumbnail-editor", {
                                attrs: { item: _vm.item },
                                on: {
                                  done: function($event) {
                                    _vm.thumbnailEditor = false
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.item.media && !_vm.thumbnailEditor && !_vm.chapterEditor
                    ? _c(
                        "div",
                        {
                          staticClass: "testqs",
                          class: { open: _vm.testEditor }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "testqs-box",
                              on: {
                                click: function($event) {
                                  _vm.testEditor = !_vm.testEditor
                                }
                              }
                            },
                            [_c("i")]
                          ),
                          _vm._v(" "),
                          _vm.testEditor
                            ? _c("test-editor", {
                                attrs: { item: _vm.item },
                                on: {
                                  done: function($event) {
                                    _vm.testEditor = false
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.item.media && !_vm.thumbnailEditor && !_vm.testEditor
                    ? _c(
                        "div",
                        {
                          staticClass: "chapters",
                          class: { open: _vm.chapterEditor }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "chapters-box",
                              on: {
                                click: function($event) {
                                  _vm.chapterEditor = !_vm.chapterEditor
                                }
                              }
                            },
                            [_c("i")]
                          ),
                          _vm._v(" "),
                          _vm.chapterEditor
                            ? _c("chapter-editor", {
                                attrs: { item: _vm.item },
                                on: {
                                  done: function($event) {
                                    _vm.chapterEditor = false
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("dyn-textarea", {
                  staticClass: "title-input",
                  attrs: { placeholder: "Enter title here" },
                  on: { keydown: _vm.titleKeyDown },
                  model: {
                    value: _vm.item.title,
                    callback: function($$v) {
                      _vm.$set(_vm.item, "title", $$v)
                    },
                    expression: "item.title"
                  }
                }),
                _vm._v(" "),
                _c("ul", { staticClass: "details-list" }, [
                  _c("li", { staticStyle: { width: "100%" } }, [
                    _c("label", [_vm._v("Date:")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.item.created,
                          expression: "item.created"
                        }
                      ],
                      ref: "createdDate",
                      staticClass: "datepicker-field",
                      domProps: { value: _vm.item.created },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.item, "created", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  !_vm.item.parent
                    ? _c("li", [
                        _c("label", [_vm._v("1 day (USD):")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.item.priceUsd,
                              expression: "item.priceUsd"
                            }
                          ],
                          staticClass: "price-box",
                          attrs: { type: "text" },
                          domProps: { value: _vm.item.priceUsd },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.item,
                                "priceUsd",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.item.parent
                    ? _c("li", [
                        _c("label", [_vm._v("3 days:")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.item.price1,
                              expression: "item.price1"
                            }
                          ],
                          staticClass: "price-box",
                          attrs: { type: "text" },
                          domProps: { value: _vm.item.price1 },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.item, "price1", $event.target.value)
                            }
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.item.parent
                    ? _c("li", [
                        _c("label", [_vm._v("7 days:")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.item.price2,
                              expression: "item.price2"
                            }
                          ],
                          staticClass: "price-box",
                          attrs: { type: "text" },
                          domProps: { value: _vm.item.price2 },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.item, "price2", $event.target.value)
                            }
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.item.parent
                    ? _c("li", [
                        _c("label", [_vm._v("30 days:")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.item.price3,
                              expression: "item.price3"
                            }
                          ],
                          staticClass: "price-box",
                          attrs: { type: "text" },
                          domProps: { value: _vm.item.price3 },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.item, "price3", $event.target.value)
                            }
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.item.parent
                    ? _c("li", [
                        _c("label", [_vm._v("90 days:")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.item.price4,
                              expression: "item.price4"
                            }
                          ],
                          staticClass: "price-box",
                          attrs: { type: "text" },
                          domProps: { value: _vm.item.price4 },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.item, "price4", $event.target.value)
                            }
                          }
                        })
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("ul", { staticClass: "details-list details-discount" }, [
                  _c("li", { staticStyle: { width: "40%" } }, [
                    _c("label", [_vm._v("Discount expiry:")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.item.discountexpiry,
                          expression: "item.discountexpiry"
                        }
                      ],
                      ref: "discountexpiry",
                      staticClass: "datepicker-field",
                      domProps: { value: _vm.item.discountexpiry },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.item,
                            "discountexpiry",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("li", { staticStyle: { width: "30%" } }, [
                    _c("label", [_vm._v("Code:")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.item.discountkey,
                          expression: "item.discountkey"
                        }
                      ],
                      attrs: { type: "text" },
                      domProps: { value: _vm.item.discountkey },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.item, "discountkey", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("li", { staticStyle: { width: "20%" } }, [
                    _c("label", [_vm._v("Percent:")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.item.discountpercent,
                          expression: "item.discountpercent"
                        }
                      ],
                      staticClass: "price-box",
                      attrs: { type: "text" },
                      domProps: { value: _vm.item.discountpercent },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.item,
                            "discountpercent",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "post-content" },
            [
              _c(
                "div",
                { staticClass: "auth auth-edit" },
                [
                  _vm.item.author
                    ? [
                        _c(
                          "div",
                          { staticClass: "auth-img" },
                          [
                            _c("i"),
                            _vm._v(" "),
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: "content.teacher",
                                    params: { id: _vm.item.author.username }
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: _vm.photoLinkR(
                                      _vm.item.author.media,
                                      256,
                                      256,
                                      "Fit"
                                    )
                                  }
                                })
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _c("div", { staticClass: "name" }, [
                            _vm._v(
                              _vm._s(
                                _vm.item.author.pubname ||
                                  _vm.item.author.firstname +
                                    " " +
                                    _vm.item.author.lastname
                              )
                            )
                          ])
                        ])
                      ]
                    : _c("div", [_vm._v("(no author)")]),
                  _vm._v(" "),
                  _vm.isAdmin
                    ? _c(
                        "ul",
                        _vm._l(_vm.authors, function(type) {
                          return _c(
                            "li",
                            {
                              class: {
                                active:
                                  _vm.item.author &&
                                  type.id == _vm.item.author.id
                              },
                              staticStyle: {
                                "white-space": "nowrap",
                                overflow: "hidden",
                                "text-overflow": "ellipsis"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.select("author", type)
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  type.pubname ||
                                    type.firstname + " " + type.lastname
                                )
                              )
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "draggable",
                {
                  attrs: { handle: ".drag" },
                  model: {
                    value: _vm.item.blocks,
                    callback: function($$v) {
                      _vm.$set(_vm.item, "blocks", $$v)
                    },
                    expression: "item.blocks"
                  }
                },
                [
                  _vm._l(_vm.item.blocks, function(block, bi) {
                    return [
                      block.type == "intro"
                        ? _c("edit-intro", {
                            key: "item" + (block.id || block.tempId),
                            attrs: { block: block },
                            on: {
                              "new-block": function($event) {
                                return _vm.newBlock(bi, $event)
                              },
                              remove: function($event) {
                                return _vm.removeBlock(bi)
                              }
                            },
                            model: {
                              value: block.content,
                              callback: function($$v) {
                                _vm.$set(block, "content", $$v)
                              },
                              expression: "block.content"
                            }
                          })
                        : block.type == "text"
                        ? _c("edit-text", {
                            key: "item" + (block.id || block.tempId),
                            attrs: { block: block },
                            on: {
                              "new-block": function($event) {
                                return _vm.newBlock(bi, $event)
                              },
                              remove: function($event) {
                                return _vm.removeBlock(bi)
                              }
                            },
                            model: {
                              value: block.content,
                              callback: function($$v) {
                                _vm.$set(block, "content", $$v)
                              },
                              expression: "block.content"
                            }
                          })
                        : block.type == "image"
                        ? _c("edit-image", {
                            key: "item" + (block.id || block.tempId),
                            attrs: { block: block },
                            on: {
                              remove: function($event) {
                                return _vm.removeBlock(bi)
                              }
                            },
                            model: {
                              value: block.content,
                              callback: function($$v) {
                                _vm.$set(block, "content", $$v)
                              },
                              expression: "block.content"
                            }
                          })
                        : block.type == "h2"
                        ? _c("edit-h2", {
                            key: "item" + (block.id || block.tempId),
                            attrs: { block: block },
                            on: {
                              "new-block": function($event) {
                                return _vm.newBlock(bi, $event)
                              },
                              remove: function($event) {
                                return _vm.removeBlock(bi)
                              }
                            },
                            model: {
                              value: block.content,
                              callback: function($$v) {
                                _vm.$set(block, "content", $$v)
                              },
                              expression: "block.content"
                            }
                          })
                        : block.type == "blockquote"
                        ? _c("edit-blockquote", {
                            key: "item" + (block.id || block.tempId),
                            attrs: { block: block },
                            on: {
                              "new-block": function($event) {
                                return _vm.newBlock(bi, $event)
                              },
                              remove: function($event) {
                                return _vm.removeBlock(bi)
                              }
                            },
                            model: {
                              value: block.content,
                              callback: function($$v) {
                                _vm.$set(block, "content", $$v)
                              },
                              expression: "block.content"
                            }
                          })
                        : _vm._e()
                    ]
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "pe-toolbar" }, [
                _c("div", { staticClass: "pet-inner" }, [
                  _c("ul", [
                    _c("li", { staticClass: "intro" }, [
                      _c(
                        "a",
                        {
                          attrs: { href: "" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.newBlockType("intro")
                            }
                          }
                        },
                        [
                          _c("span", [_vm._v("add")]),
                          _c("i"),
                          _c("em", [_vm._v("Intro")])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "text" }, [
                      _c(
                        "a",
                        {
                          attrs: { href: "" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.newBlockType("text")
                            }
                          }
                        },
                        [
                          _c("span", [_vm._v("add")]),
                          _c("i"),
                          _c("em", [_vm._v("Text")])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "image" }, [
                      _c(
                        "a",
                        {
                          attrs: { href: "" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.newBlockType("image")
                            }
                          }
                        },
                        [
                          _c("span", [_vm._v("add")]),
                          _c("i"),
                          _c("em", [_vm._v("Image/File")])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "quote" }, [
                      _c(
                        "a",
                        {
                          attrs: { href: "" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.newBlockType("blockquote")
                            }
                          }
                        },
                        [
                          _c("span", [_vm._v("add")]),
                          _c("i"),
                          _c("em", [_vm._v("Quote")])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "h2" }, [
                      _c(
                        "a",
                        {
                          attrs: { href: "" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.newBlockType("h2")
                            }
                          }
                        },
                        [
                          _c("span", [_vm._v("add")]),
                          _c("i"),
                          _c("em", [_vm._v("Heading")])
                        ]
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("edit-tags", { attrs: { item: _vm.item } })
            ],
            1
          ),
          _vm._v(" "),
          false
            ? _c(
                "div",
                { staticClass: "post-comments" },
                [
                  _c("div", { staticClass: "comments-toggle" }, [
                    _c("label", { staticClass: "check" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.item.hasComments,
                            expression: "item.hasComments"
                          }
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.item.hasComments)
                            ? _vm._i(_vm.item.hasComments, null) > -1
                            : _vm.item.hasComments
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.item.hasComments,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.item,
                                    "hasComments",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.item,
                                    "hasComments",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.item, "hasComments", $$c)
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("i"),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          "Comments are " +
                            _vm._s(_vm.item.hasComments ? "On" : "Off")
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("h4", [
                    _vm._v(
                      _vm._s(
                        _vm.formatPlural(_vm.item.comments.length, "comment")
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("edit-comments", {
                    attrs: { item: _vm.item },
                    model: {
                      value: _vm.item.comments,
                      callback: function($$v) {
                        _vm.$set(_vm.item, "comments", $$v)
                      },
                      expression: "item.comments"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "form-act" }, [
            _c(
              "button",
              {
                staticClass: "lbtn",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.saveItem($event)
                  }
                }
              },
              [_vm._v("Save")]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }